import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';

import { ParagonHeader } from '@paragon/material';
import { UserDropdown } from '@paragon/themes';

import accountsLogoUrl from '../../../resources/accounts.png';

interface Props {
  readonly onNavigationMenuClick: () => void;
}

export function Header({ onNavigationMenuClick }: Props) {
  return (
    <ParagonHeader
      text="PARAGON ACCOUNTS"
      clientLogoUrl={accountsLogoUrl}
      clientName="Paragon Accounts"
      toolbarSx={{ justifyContent: { xs: 'space-between' } }}
    >
      <UserDropdown sx={{ color: '#fff' }} />
      <IconButton
        aria-label="Open navigation"
        onClick={onNavigationMenuClick}
        sx={{ color: '#fff', display: { md: 'none' } }}
      >
        <MenuIcon />
      </IconButton>
    </ParagonHeader>
  );
}
